
import Vue from "vue";
import {VFadeTransition} from "vuetify/lib";

export default Vue.extend({
    name: "imam-reza-features",

    components: {VFadeTransition},

    data() {
        return {
            features: [
                {
                    id: 1,
                    name: "زیارت نیابتی حرم امام رضا (علیه السلام)",
                    desc: "ما نایب الزیاره شما هستیم",
                    // desc: "در حال حاضر امکان زیارت نیابتی حرم امام رضا وجود ندارد.",
                    image: require("@/assets/img/emamRezaDetails2.png"),
                    disabled: false,
                },
                {
                    id: 2,
                    name: "پخش زنده حرم مطهر امام رضا (علیه السلام)",
                    desc: "میهمان حرم رضوی باشید",
                    image: require("@/assets/img/emamRezaDetails1.png"),
                },
            ],
        };
    },
    methods: {
        handelClickFeautres(item) {
            if (item.disabled) return;

            switch (item.id) {
                case 1:
                    // http://ziarat.mojtel.ir/docs/static/index.html#/auth/AuthController_redirect // generate token for test locally
                    // window.open(
                    //   "https://tv.razavi.ir/fa/ziyarat-badesaba/" +
                    //     this.$store.state.queryParams?.token,
                    //   "_self"
                    // );
                    const test = this.$store.state.queryParams?.token;
                    debugger
                    window.open(
                        "https://haram.razavi.ir/ziyarat-badesaba?token=" +
                        this.$store.state.queryParams?.token,
                        "_blank"
                    );
                    break;

                case 2:
                    window.open("http://live.badesaba.ir/?type=imamreza", "_self");
                    break;

                default:
                    break;
            }
        },
    },
});
